import Vue from "vue";

const addRupeeSymbol = function(value) {
  return domParser() + " " + value;
};

const domParser = function() {
  let sign = "&#8377;";
  let parser = new DOMParser();
  let dom = parser.parseFromString("<!doctype html><body>" + sign, "text/html");
  return dom.body.textContent;
};

Vue.filter("indianrupee", addRupeeSymbol);
